import React from 'react';
import { useHistory } from 'react-router-dom';
import { canModifyContent } from '@/lib/account-roles';
import {
  usePerformersQuery,
  usePerformerTypesQuery,
} from '@/queries/performers';
import { useAuthStore } from '@/stores/auth-store';
import {
  HOME_TABS,
  useHomeDashboardStore,
} from '@/stores/home-dashboard-store';
import { FestivalHeader, Loading } from '../controls';
import { PerformerTable } from './';

export function Performers() {
  const history = useHistory();
  const currentUser = useAuthStore((s) => s.currentUser);
  const canModify = canModifyContent(currentUser);
  const setActiveTab = useHomeDashboardStore((s) => s.setActiveTab);
  const performersQ = usePerformersQuery();
  const typesQ = usePerformerTypesQuery();

  const performers = performersQ.data ?? [];
  const loading =
    performersQ.isPending ||
    performersQ.isFetching ||
    typesQ.isPending ||
    typesQ.isFetching;

  return (
    <>
      <FestivalHeader
        variant="bethere"
        title="My Performers"
        subtitle="These are performers you've used before. You can reuse or select them from your list the next time you create an event, or add new ones during event creation."
        showAdd={canModify}
        addTitle="Add Performer"
        addAction={() => {
          if (!canModify) {
            return;
          }
          setActiveTab(HOME_TABS.performers);
          history.push('/performer/new');
        }}
      />
      {loading ? (
        <Loading />
      ) : (
        <PerformerTable performers={performers} canModify={canModify} />
      )}
    </>
  );
}
